import React from 'react';
import PropTypes from 'prop-types';

class CategorySearchInput extends React.Component {
    handleChange = e => {
        if (this.props.handleChange) this.props.handleChange(e);
    };

    render() {

        return (
            <span>
                        <input
                            ref={input => (this.titleSearchInput = input)}
                            type="text"
                            name="category-task-filter"
                            onChange={this.handleChange}
                            className="filter-input-box-category"
                            value={this.props.defaultValue}
                            placeholder={this.props.placeholderText}
                            autoFocus
                        />
             </span>
        );
    }
}

CategorySearchInput.propTypes = {
    handleChange:       PropTypes.func.isRequired,
    defaultValue:       PropTypes.string,
    placeholderText:    PropTypes.string
};

export default CategorySearchInput;



// WEBPACK FOOTER //
// ./src/containers/_shared/Fields/CategorySearchInput.js